import { render, staticRenderFns } from "./VerticalLayout.vue?vue&type=template&id=5e99300e"
import script from "./VerticalLayout.vue?vue&type=script&lang=js"
export * from "./VerticalLayout.vue?vue&type=script&lang=js"
import style0 from "./VerticalLayout.vue?vue&type=style&index=0&id=5e99300e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports